<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';

defineProps({
  value: { type: String, default: 'manual' },
  error: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['update']);
const { t } = useI18n();
</script>

<template>
  <LaisCard
    :title="t('SALES.DELIVERY.RECEIPT.TITLE')"
    prefix-icon="i-lucide-file-signature"
  >
    <div class="grid gap-3 md:grid-cols-2">
      <button
        v-for="option in [
          { value: 'manual', label: t('SALES.DELIVERY.RECEIPT.MANUAL') },
          { value: 'docusign', label: t('SALES.DELIVERY.RECEIPT.DOCUSIGN') },
        ]"
        :key="option.value"
        type="button"
        class="rounded-lais border p-4 text-left transition"
        :class="
          value === option.value
            ? 'border-lais-primary bg-lais-primary-50'
            : 'border-lais-border bg-white'
        "
        :disabled="disabled"
        @click="emit('update', option.value)"
      >
        <span class="font-semibold text-lais-text">{{ option.label }}</span>
      </button>
    </div>
    <p v-if="error" class="mt-2 text-xs text-lais-danger">{{ error }}</p>
    <p class="mt-4 text-sm text-lais-text-muted">
      {{ t('SALES.DELIVERY.RECEIPT.WARNING') }}
    </p>
  </LaisCard>
</template>
